import React, { useState } from "react";
import  './Resources/Actions.css';
import Header from "./Header";
import Navbar from "./navbar";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import './App.css';


export default function Actions(){
        
    const location = useLocation();
    const navigate = useNavigate();
    const {cusid,cusname,place,custom} = location.state;
    const [loanlist,setLoanlist] = useState([]);
    const [setting, setSetting] = useState([]);
    const API_URL = process.env.REACT_APP_WEB_API_KEY;
    var dialogclick = 0;
    
    
    useEffect( () => {
        
            fetch(API_URL+"api/Loan/GetLoan?id="+ cusid)
            .then(response => response.json())
            .then(data => {setLoanlist(data)});

            fetch(API_URL+"api/ReceiptKey/GetCommonSettings")
            .then(res=>res.json())
            .then((data)=>{setSetting(data)});
        },[])
   
            console.log(loanlist);

    function showOKdialog()
    {
        if(dialogclick === 1)
        {
            const dialog = document.getElementById('activeLoanDialog');
            dialog.showModal();
            
        }
        else
        {
            const dialog = document.getElementById('noActiveLoanDialog');
            dialog.showModal();
        }
    }
   function closedialog()
   {
    if(dialogclick === 1)
        {
            const dialog = document.getElementById('activeLoanDialog');
            dialog.close();
            
        }
        else
        {
            const dialog = document.getElementById('noActiveLoanDialog');
            dialog.close();
        }
   }    
   
    return(
        <>  
            <Header/>
            <Navbar/>
            <lable for='cusid'>Customer Id</lable><br/>
            <input id ='cusid' value= {cusid} style ={{height:"30px", width:"96%",borderRadius:"5px"}}></input><br/>
            <lable for='cusname'>Customer Name</lable><br/>
            <input id ='cusname'value = {cusname} style ={{height:"30px",width:"96%",borderRadius:"5px"}}></input><br/>
            <lable for='city'>Place</lable><br/>
            <input id ='city' value={place} style ={{height:"30px",width:"96%",borderRadius:"5px"}}></input><br/>
            
            <div className="styles" onClick={()=>{navigate('/editperson', {state:{cusid,cusname,place,custom}})}} >Edit Customer</div>
            <div className="styles" onClick={()=>{
                if(loanlist.length !== 0)
                {
                    dialogclick = 1;
                    showOKdialog();
                }
                else
                {
                    navigate('/newloan', {state:{cusid,cusname,place,custom,setting}})
                }
            }}>New Loan</div>
            <div id="payment" className="styles" onClick={()=>{
                if(loanlist.length === 0)
                {
                    showOKdialog();
                }
                else
                {
                    navigate('/payment', {state:{cusid,cusname,place,loanlist,custom}})
                }
                }}>Payment</div>
            <div id="ledger" className="styles" onClick={()=>{
                if (loanlist.length === 0)
                {
                    showOKdialog();
                }
                else
                {
                    navigate('/ledger', {state:{cusid,cusname,place,loanlist,custom}})
                }}}> Ledger</div>
            <div className="backbutton" onClick={()=>{navigate('/home')}}>Back</div>

            <dialog id="activeLoanDialog"  className="okdialog"><p>The Cutomer Has One ACTIVE Loan Currently</p>
            <button className="okdialogbutton" onClick={()=>{closedialog()}}>OK</button>
            </dialog>

            <dialog id="noActiveLoanDialog" className="okdialog"><p>There is no ACTIVE Loan for selected Customer</p>
            <button className="okdialogbutton" onClick={()=>{closedialog()}}>OK</button>
            </dialog>
        </>
    )
}